import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AngularNodeViewComponent } from 'ngx-tiptap';
import { AvatarComponent } from '../../avatar/avatar.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MentionedUser, MentionListResponse } from '../mention.model';
import { ScrollBottomDirective } from '../../../directives/scroll-bottom.directive';
import { LoaderComponent } from '../../loader/loader.component';
import { SuggestionProps } from '@tiptap/suggestion';

@Component({
  selector: 'lib-mention-list',
  imports: [
    AvatarComponent,
    TranslocoPipe,
    ScrollBottomDirective,
    LoaderComponent,
  ],
  templateUrl: './mention-list.component.html',
  styleUrl: './mention-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MentionListComponent extends AngularNodeViewComponent {
  props = input.required<SuggestionProps>();
  itemSelected = output<MentionedUser>();
  pageChange = output<number>();
  meta = input<MentionListResponse['meta']>();
  isLoading = input<boolean>(false);

  selectItem(index: number) {
    const item = this.props()?.['items'][index];
    this.itemSelected.emit(item);

    if (item) {
      this.props()?.['command']({ id: item.value, label: item.label });
    }
  }

  loadMore() {
    if (this.isLoading()) return;
    const meta = this.meta();
    if (meta && meta.current_page < meta.last_page) {
      this.pageChange.emit((meta?.current_page || 0) + 1);
    }
  }
}
